import { fork, put, all, call, takeLatest } from "redux-saga/effects";

import {
  createOrgBillingUsageSuccessful,
  createOrgBillingUsageFailure,
  getOrgBillingUsageSuccessful,
  getOrgBillingUsageFailure,
  clearAllOrgBillingUsageMessagesSuccessful,
} from "./organizationBillingUsageSlice";

import {
  createOrgBillingUsage as createOrgBillingUsageApi,
  getOrgBillingUsage as getOrgBillingUsageApi,
} from "../../helpers/auth_helper";

function* createOrgBillingUsage({ payload: createOrgBillingUsagePayload }) {
  try {
    const response = yield call(createOrgBillingUsageApi, createOrgBillingUsagePayload);
    console.log("createOrgBillingUsage Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      console.log("createOrgBillingUsage Response after deleting status: ", response);
      yield put(createOrgBillingUsageSuccessful(response.data));
    }
    else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(createOrgBillingUsageFailure({ message: message }));
    }
  } catch (error) {
    console.log("createOrgBillingUsage Error: ", error);
    if(error.response){
      yield put(createOrgBillingUsageFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(createOrgBillingUsageFailure({message: "No response is received"}))
    } else{
      yield put(createOrgBillingUsageFailure({message: error?.message}));
    }
  }
}

function* getOrgBillingUsage({ payload: accnumber }) {
  try {
    const response = yield call(getOrgBillingUsageApi, accnumber);
    console.log("getOrgBillingUsage Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      console.log("getOrgBillingUsage Response after deleting status: ", response);
      yield put(getOrgBillingUsageSuccessful(response));
    }
    else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(getOrgBillingUsageFailure({ message: message }));
    }
  } catch (error) {
    console.log("getOrgBillingUsage Error: ", error);
    if(error.response){
      yield put(getOrgBillingUsageFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(getOrgBillingUsageFailure({message: "No response is received"}))
    } else{
      yield put(getOrgBillingUsageFailure({message: error?.message}));
    }
  }
}


export function* clearAllOrgBillingUsageMessages() {
  console.log("clearAllOrgBillingUsageMessages Saga: clear all messages");
  yield put((clearAllOrgBillingUsageMessagesSuccessful()));
}

function* watchOrganizationBillingUsageSaga() {
  yield takeLatest("organizationBillingUsageSlice/createOrgBillingUsage", createOrgBillingUsage);
  yield takeLatest("organizationBillingUsageSlice/getOrgBillingUsage", getOrgBillingUsage);
  yield takeLatest("organizationBillingUsageSlice/clearAllOrgBillingUsageMessages", clearAllOrgBillingUsageMessages);
}

function* organizationBillingUsageSaga() {
  yield all([fork(watchOrganizationBillingUsageSaga)]);
}

export default organizationBillingUsageSaga;